import React from 'react';

export default function Content(props) {

    return (
        <div className="content-container">{props.children}</div>
    );
}